import { StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const rootStyles: StyleSystemProps = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignSelf: 'center',
  alignItems: 'center',
};

const showcaseContainerStyles: StyleSystemProps = {
  width: '100%',
  marginTop: pxToRem(32),
};

export const styles = {
  root: rootStyles,
  showcaseContainer: showcaseContainerStyles,
};
